import React from 'react';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import PropTypes from 'prop-types';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import classNames from 'classnames';
import useMobileLayout from 'Hooks/useMobileLayout';
import BigPickListTemplateContent from 'Views/Page/Content/Templates/BigPickListTemplate/Content';

const styles = (theme) => ({
  root: {
    width: '100%',
    margin: 'auto',
    display: 'flex',
    maxWidth: '400px',
    alignItems: 'center',
    flexDirection: 'column',
    marginBottom: theme.spacing(10),
    padding: theme.spacing(2),
  },
  rootDesktop: {
    maxWidth: '600px',
  },
  badgeImage: {
    marginBottom: theme.spacing(2),
    width: 72,
    height: 72,
  },
});

function Layout({
  classes,
}) {
  const {
    resource,
  } = useMetaLayoutContext();


  const isMobile = useMobileLayout();

  return (
    <div className={classNames(classes.root, {
      [classes.rootDesktop]: !isMobile,
    })}
    >
      {
        resource.attr('badgeImage')
          ? <img className={classes.badgeImage} src={resource.attr('badgeImage')} alt={resource.attr('badgeImageAlt')} />
          : undefined
      }
      <BigPickListTemplateContent />
    </div>
  );
}

Layout.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Layout);
